export default "__VITE_ASSET__bc0c28fe__"